module.exports = __webpack_public_path__ + "static/header_tit_bg@2x-a3c685736247d8c4d6f6879c3417583a.png";